import React from "react";

import { MenuItem } from './ContextMenu.interfaces.ts';
import { useShowActionsMenu } from "../ActionsMenu/hooks/useShowActionsMenu.js";
import { IconButton } from "../IconButton/IconButton.js";

export const ContextMenu = ({
    id,
    items,
}: { id: number, items: MenuItem[] }) => {
    const [showMenuActions] = useShowActionsMenu();

    const menuItems: any[] = [];


    for (const item of items) {
        if (item.allow || !('allow' in item)) {
            menuItems.push({
                ...item,
            });
        }
    }

    const optionsClassName =
        menuItems.length > 0
            ? "btn-primary IconButton primary trigger-actions-menu"
            : "IconButton gray trigger-actions-menu";

    const optionsIconName = menuItems.length > 0 ? "options" : "options-gray";

    const menuOptions = {
        items: menuItems,
        minMenuHeight: 35 * menuItems.length,
        offsetY: 7,
    };

    return (
        <IconButton key={id}
            iconName={optionsIconName}
            className={optionsClassName}
            onClick={showMenuActions(menuOptions)}
        />
    );
};